(function () {
  function init() {
    var stickyBars = document.querySelectorAll('[id^="StickyAddToCart-"]');
    if (!stickyBars.length) return;

    stickyBars.forEach(function (stickyBar) {
      try {
        setupStickyBar(stickyBar);
      } catch (e) {
        console.error('[StickyAddToCart] init error:', e);
      }
    });
  }

  function setupStickyBar(stickyBar) {
    var sectionId = stickyBar.id.replace('StickyAddToCart-', '');
    var submitButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var form = document.getElementById('product-form-' + sectionId);
    var stickyButton = stickyBar.querySelector('.sticky-add-to-cart__button');
    var stickyPrice = stickyBar.querySelector('.sticky-add-to-cart__price');

    if (!submitButton || !stickyButton || !form) return;

    // Show sticky bar only after scrolling past a threshold
    var showOffset = window.innerHeight * 0.8;
    function onScroll() {
      stickyBar.classList.toggle('is-visible', window.pageYOffset > showOffset);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Click -> scroll to the original submit button area
    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) return;
      var target = submitButton.closest('.product-form__buttons') || submitButton;
      var offset = target.getBoundingClientRect().top + window.pageYOffset - 300;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    });

    // Variant change subscription
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          try {
            var data = event.data;
            if (data.sectionId !== sectionId) return;

            // Update price
            if (data.html && stickyPrice) {
              var priceSource = data.html.getElementById('price-' + sectionId);
              if (priceSource) {
                var salePrice = priceSource.querySelector('.price-item--sale');
                var regularPrice = priceSource.querySelector('.price-item--regular');
                var displayPrice = salePrice || regularPrice;
                if (displayPrice) {
                  stickyPrice.textContent = displayPrice.textContent.trim();
                }
              }
            }

            // Update button state
            var variant = data.variant;
            if (variant && variant.available) {
              stickyButton.disabled = false;
              stickyButton.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'カートに追加する';
            } else {
              stickyButton.disabled = true;
              stickyButton.textContent = (window.variantStrings && window.variantStrings.soldOut) || '売り切れ';
            }
          } catch (e) {
            console.error('[StickyAddToCart] variantChange error:', e);
          }
        });
      }
    } catch (e) {
      console.error('[StickyAddToCart] subscribe error:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
